import script from "./error.vue?vue&type=script&setup=true&lang=ts"
export * from "./error.vue?vue&type=script&setup=true&lang=ts"

import "./error.vue?vue&type=style&index=0&id=a6c04d54&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6c04d54"]])

export default __exports__